import React from 'react';

import { VOID_FUNCTION } from 'constants/index';
import { DatePicker as DatePickerBase } from 'components/uikit/Form/Datepicker/DatePicker';

import { withNormalizedTextInputStyles } from '../../hocs/withNormalizedTextInputStyles';

import { DATE_FORMAT_FOR_STORE, DATE_FORMAT_PROP } from './DatePicker.constants';
import { useDatePickerPresenter } from './DatePicker.presenter';

const NormalizedDatePicker = withNormalizedTextInputStyles(DatePickerBase, {
  dateFormat: DATE_FORMAT_PROP,
  size: 'm',
  theme: '2',
});

export const DatePicker = ({
  onChange = VOID_FUNCTION,
  onBlur = VOID_FUNCTION,
  outputFormat = DATE_FORMAT_FOR_STORE,
  value = '',
  ...rest
}) => {
  const presenter = useDatePickerPresenter({ onChange, onBlur, outputFormat, value });

  return <NormalizedDatePicker {...rest} onBlur={presenter.onBlur} value={presenter.value} />;
};
